import React from "react"

const NotificationEditItemDetails = ({
    title,
    message,
    send_push,
    onEventChange,
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <i className="icon icon-headline" />
                Title
            </h3>
            <input
                type="text"
                name="title"
                className="form-control"
                placeholder="Title"
                value={title}
                onChange={onEventChange}
            />
            <h3>
                <i className="icon icon-description" />
                Message
            </h3>
            <textarea
                name="message"
                className="form-control"
                placeholder="Message"
                value={message}
                onChange={onEventChange}
            />
            <h3>
                <i className="icon icon-notification" />
                Push notifications
            </h3>
            <label>
                <input
                    type="checkbox"
                    name="send_push"
                    checked={send_push}
                    onChange={onEventChange}
                />{" "}
                {send_push ? "On" : "Off"}
            </label>
        </div>
    </div>
)

export default NotificationEditItemDetails
